import { ColumnDef, flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { AnimationShell, Typography } from '@/components';
import { getWidthClass } from '@/helpers/table-columns-width';

import { OfferItemList } from '@/features/offers/types';
import { myOffersColumns } from './my-offers-column-header';
import { MyOffersRow } from './my-offers-row';

export function MyOffersTable({ offers }: any) {
  const columns: ColumnDef<OfferItemList>[] = myOffersColumns();

  const table = useReactTable({
    data: offers,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    // <div className="space-y-2">
    <AnimationShell type="opacity" className="grid place-items-stretch gap-6">
      <div className="bg-neutral-10 overflow-x-auto rounded-md border-2 border-neutral-50">
        <Table className="w-full min-w-175 lg:min-w-0">
          <TableHeader>
            {table.getHeaderGroups().map((headerGroup) => (
              <TableRow key={headerGroup.id} className="hover:bg-muted border-neutral-100">
                {headerGroup.headers.map((header) => {
                  const widthClass = getWidthClass('asBuyer', header.column.id);
                  return (
                    <TableHead key={header.id} className={`px-3 py-4 ${widthClass}`}>
                      <Typography
                        as="h6"
                        size="body-2"
                        weight="semibold"
                        className="whitespace-nowrap text-neutral-500"
                      >
                        {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                      </Typography>
                    </TableHead>
                  );
                })}
              </TableRow>
            ))}
          </TableHeader>
          <TableBody>
            {table.getRowModel().rows?.length ? (
              table.getRowModel().rows.map((row) => <MyOffersRow key={row.id} row={row} />)
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length} className="h-24 text-center">
                  No results.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </AnimationShell>
  );
}
